module.exports = __webpack_public_path__ + "static/media/anomoly.9e035c4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/anomoly.mp3
// module id = ARwj
// module chunks = 0